import { fork, takeEvery } from "redux-saga/effects";

import MainConstants from "modules/main/constants";
import MainSagas from "modules/main/sagas";
import MainActions from "modules/main/actions";

function* watchAuthAdpro() {
  console.log("auth");
  yield takeEvery(MainConstants.AUTH_ADPRO, MainSagas.AuthAdpro);
}

function* watchSetAd() {
  yield takeEvery(MainConstants.AD, MainSagas.SetAd);
}

function* watchSetFacebookAd() {
  yield takeEvery(MainConstants.FACEBOOK_AD, MainSagas.SetFacebookAd);
}

function* watchSendAnalyticsPageView() {
  yield takeEvery(MainConstants.SEND_ANALYTICS_PAGE_VIEW, MainSagas.SendAnalyticsPageView);
}

function* watchSendAnalyticsLogin() {
  yield takeEvery(MainConstants.SEND_ANALYTICS_LOGIN, MainSagas.SendAnalyticsLogin);
}

function* watchCurrentDashboard() {
  yield takeEvery(MainConstants.CURRENT_DASHBOARD, MainSagas.currentDashboard);
}

function* watchLoginToRdynamic() {
  yield takeEvery(MainActions.loginToRdynamic, MainSagas.loginToRdynamic);
}

function* watchCheckAppAvailable() {
  yield takeEvery(MainActions.checkAppAvailable, MainSagas.checkAppAvailable);
}

function* watchGetNexusUserInfo() {
  yield takeEvery(MainActions.getNexusUserInfo, MainSagas.getNexusUserInfo);
}

export default [
  fork(watchAuthAdpro),
  fork(watchSetAd),
  fork(watchSetFacebookAd),
  fork(watchSendAnalyticsPageView),
  fork(watchSendAnalyticsLogin),
  fork(watchCurrentDashboard),
  fork(watchLoginToRdynamic),
  fork(watchCheckAppAvailable),
  fork(watchGetNexusUserInfo),
];
